import { UserComponent } from './components/user/user.component';
import { AclComponent } from './components/acl/acl.component';
import { ProcessTransitionComponent } from './components/process-transition/process-transition.component';
import { CollectionComponent } from './components/collection/collection.component';
import { StatusComponent } from './components/status/status.component';
import { StyleComponent } from './components/style/style.component';
import { ProductComponent } from './components/product/product.component';
import { InventoryComponent } from './components/inventory/inventory.component';
import { MainComponent } from './components/main.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthComponent } from './components/auth/auth.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { LocationComponent } from './components/location/location.component';
import { DestinationComponent } from './components/destination/destination.component';
import { ProfileComponent } from './components/profile/profile.component';
import { CustomerComponent } from './components/customer/customer.component';
import { OrderComponent } from './components/order/order.component';
import { DeliveryComponent } from './components/delivery/delivery.component';
import { PaymentComponent } from './components/payment/payment.component';
import { CategoryComponent } from './components/category/category.component';
import { SizeComponent } from './components/size/size.component';
import { DesignerComponent } from './components/designer/designer.component';
import { ConditionComponent } from './components/condition/condition.component';
import { ProcessTypesComponent } from './components/process-types/process-types.component';
import { ProcessStatusComponent } from './components/process-status/process-status.component';
import { ProviderComponent } from './components/provider/provider.component';
import { CurrencyComponent } from './components/currency/currency.component';
import { CourierComponent } from './components/courier/courier.component';
import { ColorComponent } from './components/color/color.component';
import { WardrobeComponent } from './components/wardrobe/wardrobe.component';
import {GhostComponent} from "./components/product/ghost/ghost.component";
import { CouponComponent } from './components/coupon/coupon.component';
import { CartruleComponent } from './components/cartrule/cartrule.component';
import { ProcessStatusGroupComponent } from './components/process-status-group/process-status-group.component';
import { CustomAttributeComponent } from './components/custom-attribute/custom-attribute.component';
import { CustomAttributeOptionComponent } from './components/custom-attribute-option/custom-attribute-option.component';
import { ShipmentComponent } from './components/shipment/shipment.component';

const appRoutes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      { path: '', redirectTo: 'profile', pathMatch: 'full' },
      {
        path: 'wardrobe',
        component: WardrobeComponent,
        loadChildren: 'app/components/wardrobe/wardrobe.module#WardrobeModule'
      },
      {
        path: 'color',
        component: ColorComponent,
        loadChildren: 'app/components/color/color.module#ColorModule'
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'inventory',
        component: InventoryComponent,
        loadChildren: 'app/components/inventory/inventory.module#InventoryModule'
      },
      {
        path: 'location',
        component: LocationComponent,
        loadChildren: 'app/components/location/location.module#LocationModule'
      },
      {
        path: 'destination',
        component: DestinationComponent,
        loadChildren: 'app/components/destination/destination.module#DestinationModule'
      },
      {
        path: 'profile',
        component: ProfileComponent,
        loadChildren: 'app/components/profile/profile.module#ProfileModule'
      },
      {
        path: 'customer',
        component: CustomerComponent,
        loadChildren: './components/customer/customer.module#CustomerModule'
      },
      {
        path: 'order',
        component: OrderComponent,
        loadChildren: './components/order/order.module#OrderModule'
      },
      {
        path: 'shipment',
        component: ShipmentComponent,
        loadChildren: './components/shipment/shipment.module#ShipmentModule'
      },
      {
        path: 'delivery',
        component: DeliveryComponent,
        loadChildren: './components/delivery/delivery.module#DeliveryModule'
      },
      {
        path: 'coupon',
        component: CouponComponent,
        loadChildren: './components/coupon/coupon.module#CouponModule'
      },
      {
        path: 'cartrule',
        component: CartruleComponent,
        loadChildren: './components/cartrule/cartrule.module#CartruleModule'
      },
      {
        path: 'payment',
        component: PaymentComponent,
        loadChildren: './components/payment/payment.module#PaymentModule'
      },
      {
        path: 'product',
        component: ProductComponent,
        loadChildren: './components/product/product.module#ProductModule'
      },
      {
        path: 'ghost',
        component: GhostComponent
      },
      {
        path: 'category',
        component: CategoryComponent,
        loadChildren: './components/category/category.module#CategoryModule'
      },
      {
        path: 'size',
        component: SizeComponent,
        loadChildren: './components/size/size.module#SizeModule'
      },
      {
        path: 'designer',
        component: DesignerComponent,
        loadChildren: './components/designer/designer.module#DesignerModule'
      },
      {
        path: 'style',
        component: StyleComponent,
        loadChildren: './components/style/style.module#StyleModule'
      },
      {
        path: 'status',
        component: StatusComponent,
        loadChildren: './components/status/status.module#StatusModule'
      },
      {
        path: 'condition',
        component: ConditionComponent,
        loadChildren: './components/condition/condition.module#ConditionModule'
      },
      {
        path: 'collection',
        component: CollectionComponent,
        loadChildren: './components/collection/collection.module#CollectionModule'
      },
      {
        path: 'process-type',
        component: ProcessTypesComponent,
        loadChildren: './components/process-types/process-types.module#ProcessTypesModule'
      },
      {
        path: 'process-status',
        component: ProcessStatusComponent,
        loadChildren: './components/process-status/process-status.module#ProcessStatusModule'
      },
      {
        path: 'process-status-group',
        component: ProcessStatusGroupComponent,
        loadChildren: './components/process-status-group/process-status-group.module#ProcessStatusGroupModule'
      },
      {
        path: 'process-transition',
        component: ProcessTransitionComponent,
        loadChildren: './components/process-transition/process-transition.module#ProcessTransitionModule'
      },
      {
        path: 'acl',
        component: AclComponent,
        loadChildren: './components/acl/acl.module#AclModule'
      },
      {
        path: 'user',
        component: UserComponent,
        loadChildren: './components/user/user.module#UserModule'
      },
      {
        path: 'provider',
        component: ProviderComponent,
        loadChildren: './components/provider/provider.module#ProviderModule'
      },
      {
        path: 'currency',
        component: CurrencyComponent,
        loadChildren: './components/currency/currency.module#CurrencyModule'
      },
      {
        path: 'courier',
        component: CourierComponent,
        loadChildren: './components/courier/courier.module#CourierModule'
      },
      {
        path: 'custom-attribute',
        component: CustomAttributeComponent,
        loadChildren: './components/custom-attribute/custom-attribute.module#CustomAttributeModule'
      }
    ],
    canActivate: [AuthGuardService]
  },
  {
    path: 'auth',
    component: AuthComponent,
    loadChildren: 'app/components/auth/auth.module#AuthModule'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      enableTracing: false,
      useHash: false,
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
